import React from "react";

export interface FlagProps extends React.SVGProps<SVGSVGElement> {
    size?: number;
    width?: number | string;
    height?: number | string;
    className?: string;
}

export const FlagSpain: React.FC<FlagProps> = ({
    size,
    width,
    height,
    className = "",
    ...props
}) => {
    const finalWidth = width ?? (size ? Math.round(size * 1.5) : 24);
    const finalHeight = height ?? size ?? 16;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 60 40"
            width={finalWidth}
            height={finalHeight}
            className={`inline-block shrink-0 overflow-hidden rounded-xs border border-slate-200/80 dark:border-white/20 shadow-2xs ${className}`}
            aria-hidden="true"
            {...props}
        >
            <rect width="60" height="10" fill="#AD1519" />
            <rect y="10" width="60" height="20" fill="#FABD00" />
            <rect y="30" width="60" height="10" fill="#AD1519" />

            {/* Coat of arms */}
            <g transform="translate(13, 14) scale(0.7)">
                {/* Crown */}
                <path
                    d="M0 -3 L2 -1 L4 -3 L6 -1 L8 -3 L8 0 L0 0 Z"
                    fill="#AD1519"
                    stroke="#FABD00"
                    strokeWidth="0.5"
                />
                {/* Shield */}
                <path
                    d="M0 0 L8 0 L8 7 C8 11 4 13 4 13 C4 13 0 11 0 7 Z"
                    fill="#AD1519"
                    stroke="#FFFFFF"
                    strokeWidth="0.6"
                />
                <rect x="0" y="0" width="4" height="4" fill="#C60B1E" />
                <rect x="4" y="0" width="4" height="4" fill="#FFFFFF" />
                <rect x="0" y="4" width="4" height="4" fill="#FABD00" />
                <rect x="4" y="4" width="4" height="4" fill="#C60B1E" />
                {/* Pillars */}
                <rect
                    x="-3"
                    y="1"
                    width="1.5"
                    height="10"
                    rx="0.5"
                    fill="#FFFFFF"
                />
                <rect
                    x="9.5"
                    y="1"
                    width="1.5"
                    height="10"
                    rx="0.5"
                    fill="#FFFFFF"
                />
            </g>
        </svg>
    );
};

export const FlagValencia: React.FC<FlagProps> = ({
    size,
    width,
    height,
    className = "",
    ...props
}) => {
    const finalWidth = width ?? (size ? Math.round(size * 1.5) : 24);
    const finalHeight = height ?? size ?? 16;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 60 40"
            width={finalWidth}
            height={finalHeight}
            className={`inline-block shrink-0 overflow-hidden rounded-xs border border-slate-200/80 dark:border-white/20 shadow-2xs ${className}`}
            aria-hidden="true"
            {...props}
        >
            {/* 9 Stripes: 5 yellow, 4 red (Senyera) */}
            <rect width="60" height="40" fill="#FCD116" />
            <rect y="4.44" width="60" height="4.44" fill="#CE1126" />
            <rect y="13.33" width="60" height="4.44" fill="#CE1126" />
            <rect y="22.22" width="60" height="4.44" fill="#CE1126" />
            <rect y="31.11" width="60" height="4.44" fill="#CE1126" />

            {/* Vertical Blue Hoist Band (La Corona) */}
            <rect x="0" y="0" width="16" height="40" fill="#0038A8" />
            <line
                x1="16"
                y1="0"
                x2="16"
                y2="40"
                stroke="#FCD116"
                strokeWidth="0.8"
            />

            {/* Reial Corona Valenciana */}
            {/* Crown base band */}
            <rect
                x="2.5"
                y="25"
                width="11"
                height="2.5"
                rx="0.5"
                fill="#D4AF37"
            />
            <circle cx="4" cy="26.25" r="0.7" fill="#CE1126" />
            <circle cx="6.25" cy="26.25" r="0.7" fill="#009A44" />
            <circle cx="8" cy="26.25" r="0.7" fill="#FFFFFF" />
            <circle cx="9.75" cy="26.25" r="0.7" fill="#009A44" />
            <circle cx="12" cy="26.25" r="0.7" fill="#CE1126" />

            {/* Crown Fleurons */}
            <path
                d="M8 14 C7.2 17 6 19 6 22 C6 24 7 25 8 25 C9 25 10 24 10 22 C10 19 8.8 17 8 14 Z"
                fill="#FFD700"
            />
            <path
                d="M3.5 17 C3 19 3 22 4.5 25 C5 25 5.5 24 5.2 22 C5 20 4.2 18.5 3.5 17 Z"
                fill="#FFD700"
            />
            <path
                d="M12.5 17 C13.2 18.5 12.4 20 12.2 22 C12 24 12.5 25 13 25 C14.5 22 14.5 19 14 17 Z"
                fill="#FFD700"
            />

            {/* Pearls on peaks */}
            <circle cx="8" cy="13.5" r="0.8" fill="#FFFFFF" />
            <circle cx="3.2" cy="16.5" r="0.7" fill="#FFFFFF" />
            <circle cx="12.8" cy="16.5" r="0.7" fill="#FFFFFF" />
            <circle cx="5.5" cy="19" r="0.6" fill="#FFFFFF" />
            <circle cx="10.5" cy="19" r="0.6" fill="#FFFFFF" />

            {/* Crown cap interior */}
            <path d="M4.5 24.5 Q8 21 11.5 24.5 Z" fill="#8A0000" />
        </svg>
    );
};

export const FlagUK: React.FC<FlagProps> = ({
    size,
    width,
    height,
    className = "",
    ...props
}) => {
    const finalWidth = width ?? (size ? Math.round(size * 1.5) : 24);
    const finalHeight = height ?? size ?? 16;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 60 40"
            width={finalWidth}
            height={finalHeight}
            className={`inline-block shrink-0 overflow-hidden rounded-xs border border-slate-200/80 dark:border-white/20 shadow-2xs ${className}`}
            aria-hidden="true"
            {...props}
        >
            {/* Blue background */}
            <rect width="60" height="40" fill="#012169" />

            {/* White diagonals */}
            <path
                d="M0 0 L60 40 M60 0 L0 40"
                stroke="#FFFFFF"
                strokeWidth="7"
            />

            {/* Red diagonals */}
            <path
                d="M0 0 L30 20 M60 0 L30 20 M60 40 L30 20 M0 40 L30 20"
                stroke="#C8102E"
                strokeWidth="2.5"
            />

            {/* White cross */}
            <path
                d="M30 0 L30 40 M0 20 L60 20"
                stroke="#FFFFFF"
                strokeWidth="12"
            />

            {/* Red cross */}
            <path
                d="M30 0 L30 40 M0 20 L60 20"
                stroke="#C8102E"
                strokeWidth="7"
            />
        </svg>
    );
};
